// https://console.harmony.a2z.com/ccx-chrome-documentation/docs/client-side-api/Button
export const ButtonType = Object.freeze({
  NORMAL: 'NORMAL', // Default style of button
  PRIMARY: 'PRIMARY',
  LINK: 'LINK' // A button looks like a link
});

export const ButtonState = Object.freeze({
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
  LOADING: 'LOADING'
});

export const Position = Object.freeze({
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left',
  OVERLAY: 'overlay'
});

export const ActionType = Object.freeze({
  BUTTON: 'BUTTON',
  DROPDOWN: 'DROPDOWN',
  POPOVER: 'POPOVER'
});

export interface AACButtonProps {
  readonly id: string;
  readonly state: string;
  readonly type: string;
  readonly label: string;
  readonly onClick: () => void;
  readonly tooltip?: string;
  readonly tooltipPosition?: string;
  readonly actionType?: string;
}
